import { Button } from "../shadcn/Button";

export function ErrorState({
  message,
  onRetry,
  title,
}: {
  message: string;
  onRetry?: () => void;
  title?: string;
}) {
  return (
    <div role="alert" className="space-y-3 rounded-[20px] border border-danger/40 bg-danger-surface px-5 py-7 text-center text-sm text-danger">
      {title && <h2 className="text-[21px] font-bold">{title}</h2>}
      <p>{message}</p>
      {onRetry && <Button variant="outline" onClick={onRetry}>Try again</Button>}
    </div>
  );
}
